import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Strip common file extensions (.pdf, .xlsx, etc.) from display titles */
export function stripFileExt(str: string): string {
  if (!str) return str;
  return str.replace(/\.(pdf|xlsx|xls|docx|doc|pptx|ppt)$/i, "");
}

/** Converts a string to sentence case: first letter uppercase, rest lowercase */
export function toSentenceCase(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
